
/**
 * 메시지 타입
 */
export type MessagingSendMessageBodyType = typeof MessagingSendMessageBodyType[keyof typeof MessagingSendMessageBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingSendMessageBodyType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
